(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gpt-pair-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gpt-pair-picker')) {
  customElements.define('gpt-pair-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.first = this.querySelector('[data-first-variant]');
      this.status = this.querySelector('[data-status]');
      this.choices = this.querySelector('.gpt-pair-choices');
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.querySelector('[data-open]').addEventListener('click', () => this.open());
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => { document.body.style.overflow = this.previousOverflow || ''; });
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) { const b = this.dialog.getBoundingClientRect(); if(e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) this.dialog.close(); } });
      this.first.addEventListener('change', () => this.update());
      this.choices.addEventListener('change', () => this.update());
      this.choices.addEventListener('click', e => { const button = e.target.closest('[data-add-partner]'); if (button) this.add(button); });
    }
    async open() {
      if (this.dialog.open) return;
      const section = this.closest('product-info');
      const formId = 'product-form-' + this.dataset.sectionId;
      const current = section?.querySelector('form[id="' + formId + '"] [name="id"]')?.value || this.dataset.sourceVariant;
      if (current && [...this.first.options].some(o => o.value === current && !o.disabled)) this.first.value = current;
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      this.status.textContent = this.messages.loading;
      try {
        const cartResponse = await fetch(this.dataset.root + 'cart.js', {headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error(this.messages.error);
        this.cart = await cartResponse.json();
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.cart.currency});
        if (!this.loaded) {
          const response = await fetch(this.dataset.root + 'collections/all?view=gpt-pair');
          if (!response.ok) throw new Error(this.messages.error);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const cards = [...doc.querySelectorAll('.gpt-pair__card')];
          if (!cards.length) throw new Error(this.messages.error);
          for (const original of cards) {
            const productLink = original.querySelector('a');
            if (new URL(productLink.href).pathname.endsWith('/' + this.dataset.sourceHandle)) continue;
            const article = document.createElement('article');
            const img = original.querySelector('img')?.cloneNode(true);
            if (img) article.append(img);
            const heading = document.createElement('h2');
            heading.textContent = original.querySelector('h2').textContent;
            article.append(heading);
            const label = document.createElement('label');
            label.textContent = original.querySelector('label').textContent;
            const select = original.querySelector('select').cloneNode(true);
            select.removeAttribute('id');
            [...select.options].forEach(o => { o.textContent = o.textContent.replace('Default Title', this.messages.one); });
            label.append(select); article.append(label);
            const summary = document.createElement('p'); summary.dataset.priceSummary = ''; article.append(summary);
            const button = document.createElement('button'); button.type = 'button'; button.dataset.addPartner = ''; button.textContent = this.messages.add;
            button.setAttribute('aria-label', this.messages.add + ': ' + heading.textContent);
            article.append(button); this.choices.append(article);
          }
          this.loaded = true;
        }
        this.status.textContent = '';
        this.update();
      } catch (error) { this.status.textContent = this.messages.error; }
    }
    update() {
      if (!this.money) return;
      const price = Number(this.first.selectedOptions[0]?.dataset.price);
      const exists = this.cart.items.some(item => String(item.variant_id) === this.first.value);
      this.querySelector('[data-cart-context]').textContent = exists ? this.messages.inCart : this.messages.two;
      for (const article of this.choices.children) {
        const option = article.querySelector('select').selectedOptions[0];
        const second = Number(option?.dataset.price);
        const saving = Math.round(Math.min(price, second) / 2);
        article.querySelector('[data-price-summary]').textContent = this.messages.total + ': ' + this.money.format((price + second - saving) / 100) + ' · ' + this.messages.save + ' ' + this.money.format(saving / 100);
        article.querySelector('button').disabled = this.busy || !option || option.disabled || !this.first.value;
      }
    }
    async add(button) {
      if (this.busy) return;
      const partner = button.closest('article').querySelector('select').value;
      this.busy = true; this.update();
      this.status.textContent = this.messages.adding;
      this.first.disabled = true;
      try {
        const response = await fetch(this.dataset.root + 'cart.js', {headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error(this.messages.error);
        const cart = await response.json();
        const items = [{id:partner,quantity:1}];
        if (!cart.items.some(item => String(item.variant_id) === this.first.value)) items.unshift({id:this.first.value,quantity:1});
        const addResponse = await fetch(this.dataset.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result = await addResponse.json();
        if (!addResponse.ok) throw new Error(result.description || this.messages.error);
        window.location.assign(this.dataset.root + 'cart');
      } catch (error) { this.status.textContent = error.message || this.messages.error; this.busy = false; this.first.disabled = false; this.update(); }
    }
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gpt-pair-reminder]');
    if (!button) return;
    const picker = [...document.querySelectorAll('gpt-pair-picker')].find(p => p.dataset.productId === button.dataset.gptPairReminder && p.dataset.cartMode !== 'true');
    if (picker) picker.open();
  });
}
  } catch(e) { console.error(e); }
})();

})();
